import { useEffect, useRef } from 'react';

/**
 * Custom React hook that determines if the component is being mounted for the first time.
 *
 * @returns {boolean} `true` if the component is on its first mount, otherwise `false`.
 *
 * @example
 * const isFirstMount = useFirstMount();
 * useEffect(() => {
 *   if (isFirstMount) {
 *     // Do something only on first mount
 *   }
 * }, [isFirstMount]);
 */
export const useFirstMount = (): boolean => {
  const isFirstMount = useRef(true);

  useEffect(() => {
    isFirstMount.current = false;
  }, []);

  return isFirstMount.current;
};
